import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';
import buildPath from '@/tsClient/utilities/buildPath';

const PATH_TEMPLATE = '/my/meeting-booking-links';
type THIS_API = ApiDefinition['/my/meeting-booking-links']['GET'];
type Input = THIS_API['query'];
type Output = THIS_API['response'];

const getMeetingBookingLinks = async ({ creatorSlug }: Input): Promise<Output> => {
  const path = buildPath<THIS_API>(PATH_TEMPLATE);
  const response = await noodleApiClient.get(path, {
    params: { creatorSlug },
  });
  return response.data;
};

export default getMeetingBookingLinks;
